import React from 'react';
import { withRouter } from 'react-router'
import { Link } from 'react-router-dom'
import { Layout, Icon, Tooltip} from 'antd';
import TextSelect from '../sharedComponets/ReactTextSelect';
import languageFile from '../../../public/languages/Translation';
import urlConfig from '../../config/index';
import './style.scss';
import cookie from "../../utils/cookie"
import GetDomainDetailsStore from '../../flux/dispatcher/store/GetDomainDetailsStore';

var _ = require('lodash');
const { Header } = Layout;

class HeaderBar extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            profileValue: '',
            showExpireInfo: false,
        }
    }
    cookierRead=()=> {
        if (cookie.readCookie("userName") && cookie.readCookie("userName") !== 'undefined') {
            return cookie.readCookie("userName")
        } else {
            return cookie.readCookie("userId")
        }
    }
    render() {
        var urlName = urlConfig.urlName;

        return (
            <div className="header-preview" style={{ backgroundColor: this.props.color.headerBackground }}>
                <div className="slide-icon" style={{color:this.props.color.headerIcon}}>
                    <Tooltip title={languageFile[localStorage.getItem('language')]["13837"]} placement="right">
                        <i className="material-icons">dehaze</i>
                    </Tooltip>
                </div>
                <div className="edit-icon">
                    <Tooltip title={languageFile[localStorage.getItem('language')]["10923"]} placement="right">
                       <i style={{color:this.props.color.headerIcon}} className="material-icons">create</i>
                    </Tooltip>
                </div>
                <div className="dropdown-wrapper">
                    <TextSelect
                    active={"My Profile"}
                    />
                </div>
                <ul className="header-right">
                    {GetDomainDetailsStore.getResponse().headerRight &&
                        <li className="dropdown">
                            <Tooltip title="Support" placement="left">
                                <a className="dropdown-toggle" data-toggle="dropdown">
                                    <i style={{color:this.props.color.headerIcon}} className="fa fa-life-ring"></i>
                                </a>
                            </Tooltip>
                            <ul className="dropdown-menu">
                                <li>
                                    <a 
                                    // href=" https://intercom.help/localclarity" 
                                    href="https://support.localclarity.com/portal/en/kb"
                                    target="_blank">
                                        <Icon type="question-circle" />
                                        <span>Knowledge Base</span>

                                    </a>
                                </li>
                                <li>
                                    <a 
                                    // href="https://localclarity.canny.io/feature-requests"
                                    href='https://app.loopedin.io/localclarity-mB-o/ideas'
                                     target="_blank">
                                        <Icon type="star" />
                                        <span>Feature Requests</span>
                                    </a>
                                </li>
                                <li>
                                    <a target="_blank">
                                        <Icon type="info-circle" />
                                        <span>Help Desk</span>
                                    </a>
                                </li>
                            </ul>
                        </li>}


                    <li className="dropdown" style={{ color: this.props.color.headerIcon }}>
                        <a className="dropdown-toggle" data-toggle="dropdown">
                            <span>{this.cookierRead()}</span>
                            <span className="angle-down"><i className="material-icons">expand_more</i></span>
                        </a>
                        {/* <ul className="dropdown-menu">
                            <li>
                                <a>
                                    <Icon type="logout" />
                                    <span>{languageFile[localStorage.getItem('language')]["12380"]}</span>
                                </a>
                            </li>
                        </ul> */}

                    </li>
                </ul>

            </div>
        )
    }
}

export default withRouter(HeaderBar);
